import {
  defaultClient as apolloClient,
} from '@/plugins/vue-apollo';
import { isBulkTransactionsEnabled } from '@/utils/bulkTransactionsHelper';
import {
  GET_ALL_CARD_GQL,
  CREATE_VCARD,
  GET_ALL_USER_CARD_GQL,
  GET_SELECTED_GROUP_CATEGORIES_GQL,
  GET_USER_BUDGET,
  GET_ALL_USER_CARD_PHYSICAL_GQL,
  CREATE_PHYSICAL_CARD,
  GET_USER_ASSIGN_BUDGET,
  SET_CARD_PIN,
  UPDATE_VIRTUAL_CARD,
  UPDATE_PHYSICAL_CARD,
  GET_PHYSICAL_CARD,
  GET_VIRTUAL_CARD,
  GET_TEAM_EXPENCE_CALCULATION_CARD,
  GET_TEAM_EXPENCE_CALCULATION_CARD_PROGRESSBAR,
  GET_CATEGORY_EXPENSE_CALCULATION_CARD,
  GET_CATEGORY_EXPENSE_CALCULATION_CARD_PROGRESSBAR,
  GET_ALL_MERCHANT,
  GET_ALL_MERCHANT_COMPANY_WISE,
  GET_CREADITCARD_INFO,
  GET_CLIENT_ACCESS_TOKEN,
  SET_ACTIVE_PHYSICAL_CARD_GQL,
  SET_BLOCK_CARD_GQL,
  CREATE_BULK_PHYSICAL_CARD_GQL,
  CHECK_KYC_STATUS,
  DEACTIVATE_CARD,
  SHIPPED_CARD_AT_NEW_ADDRESS,
  CREATE_VIRTUAL_CARD_FOR_TEAM,
  GET_ALL_CARD_LIST_GQL,
  GENERATE_CREDIT_CARD_STATEMENT_GQL,
  GET_STATEMENT_HISTORY_GQL,
  GET_STATEMENT_DOWNLOAD_URL_GQL,
  SET_REMOVE_STATEMENT_GQL,
  VIEW_CREDIT_CARD_STATEMENT_GQL,
  GET_CARD_WITH_COLORCODING_GQL,
  GET_CARD_LIST,
  GET_LIST_GROUP,
  GET_SINGLE_USER_CARD_GQL,
  GET_CARD_TRANSACTION_DATA_FOR_CSV_GQL,

} from '@/graphql/queries.gql';
import router from '@/router';

export default {
  namespaced: true,

  state: {
    listCategory: '',
    allcards: [],
    listuserVcard: [],
    setvcardname: '',
    setUserBudgetAmount: '',
    setUserActiveAmount: '',
    listAllPhysicalCard: [],
    setPhysicalCardName: '',
    pinSet: '',
    updatevirtualcard: [],
    updatePhysicaCard: [],
    setRefreshTimer: '',
    listOfPhysicalCard: [],
    listOfVirtualCard: [],
    teamwiseExpence: [],
    categoryExpence: [],
    teamwiseExpenceProgressBar: [],
    categoryExpenceProgressBar: [],
    categoryExpenceTime: [],
    merchantList: [],
    merchantListCompany: [],
    creditCardData: null,
    userAccessToken: null,
    isSetactivePhysicalcard: null,
    blockCard: null,
    blockCardVirtual: null,
    bulkCardDetails: null,
    kycStatus: null,
    activeStatus: null,
    teamWiseCreditCard: null,
    setShippingAddress: null,
    allCardList: null,
    creditCardStatementRes: null,
    creditCardStatementHistory: null,
    statementRemoved: null,
    viewCreditCardStatementRes: null,
    cardsWithColorCoding: null,
    listOfAllCards: [],
    listOfGroup: [],
    singleCardDetails: [],
    cardTransactionDataForCSV: null,
  },

  mutations: {
    SET_ALL_CARDS(state, payload) {
      state.allcards = payload;
    },
    SET_ALL_USER_CARDS(state, payload) {
      state.listuserVcard = payload;
    },
    SET_V_CARD(state, payload) {
      state.setvcardname = payload;
    },
    SET_PHYSICAL_CARD(state, payload) {
      state.setPhysicalCardName = payload;
    },
    SET_ALL_CATAGORY(state, payload) {
      state.listCategory = payload;
    },
    SET_USER_BUDGET(state, payload) {
      state.setUserBudgetAmount = payload;
    },
    SET_USER_ACTIVE_BUDGET(state, payload) {
      state.setUserActiveAmount = payload;
    },
    SET_ALL_PHYSICAL_CARD(state, payload) {
      state.listAllPhysicalCard = payload;
    },
    SET_CARD_PIN_1(state, payload) {
      state.pinSet = payload;
    },
    SET_UPDATE_VIRTUAL_CARD(state, payload) {
      state.updatevirtualcard = payload;
    },
    SET_UPDATE_PHYSICAL_CARD(state, payload) {
      state.updatePhysicaCard = payload;
    },
    SET_TIMER(state, payload) {
      state.setRefreshTimer = payload;
    },
    SET_GROUPWISE_PHYSICAL_CARD(state, payload) {
      state.listOfPhysicalCard = payload;
    },
    SET_GROUPWISE_VIRTULE_CARD(state, payload) {
      state.listOfVirtualCard = payload;
    },
    SET_TEAMWISE_EXPENCE_CARD(state, payload) {
      state.teamwiseExpence = payload;
    },
    SET_CATEGORYWISE_EXPENCE_CARD(state, payload) {
      state.categoryExpence = payload;
    },

    SET_TEAMWISE_EXPENCE_CARD_PROGRESSBAR(state, payload) {
      state.teamwiseExpenceProgressBar = payload;
    },
    SET_CATEGORYWISE_EXPENCE_CARD_PROGRESSBAR(state, payload) {
      state.categoryExpenceProgressBar = payload;
    },
    SET_ALL_MERCHANT(state, payload) {
      state.merchantList = payload;
    },
    SET_ALL_MERCHANT_COMPANY(state, payload) {
      state.merchantListCompany = payload;
    },
    SET_CREDITCARD_DATA(state, payload) {
      state.creditCardData = payload;
    },
    SET_CLIENT_ACCESS_TOKEN(state, payload) {
      state.userAccessToken = payload;
    },
    SET_ACTIVE_PHYSICAL_CARD(state, payload) {
      state.isSetactivePhysicalcard = payload;
    },
    SET_BLOCK_PHYSICAL_CARD(state, payload) {
      state.blockCard = payload;
    },
    SET_BLOCK_VIRTUAL_CARD(state, payload) {
      state.blockCardVirtual = payload;
    },
    SET_TEAMWISE_CREDIT_CARD(state, payload) {
      state.teamWiseCreditCard = payload;
    },
    SET_BULK_PHYSICAL_CARD(state, payload) {
      state.bulkCardDetails = payload;
    },
    SET_KYC_STATUS(state, payload) {
      state.kycStatus = payload;
    },
    SET_ACTIVE_STATUS(state, payload) {
      state.activeStatus = payload;
    },
    SET_SHIPPING_ADDRESS(state, payload) {
      state.setShippingAddress = payload;
    },
    GET_ALL_CARD_LIST(state, payload) {
      state.allCardList = payload;
    },
    GENERATE_CREDIT_CARD_STATEMENT(state, payload) {
      state.creditCardStatementRes = payload;
    },
    GET_STATEMENT_HISTORY(state, payload) {
      state.creditCardStatementHistory = payload;
    },
    SET_REMOVE_STATEMENT_GQL(state, payload) {
      state.statementRemoved = payload;
    },
    VIEW_CREDIT_CARD_STATEMENT(state, payload) {
      state.viewCreditCardStatementRes = payload;
    },
    GET_CARD_WITH_COLORCODING(state, payload) {
      state.cardsWithColorCoding = payload;
    },
    SET_LIST_OF_CARD(state, payload) {
      state.listOfAllCards = payload;
    },
    SET_LIST_OF_GROUP(state, payload) {
      state.listOfGroup = payload;
    },
    SET_SINGLE_TRANSACTSION(state, payload) {
      state.singleCardDetails = payload;
    },
    GET_CARD_TRANSACTION_DATA_FOR_CSV(state, payload) {
      state.cardTransactionDataForCSV = payload;
    },
  },
  actions: {
    // "getAllusercards" to get virtual cards in budget Screen
    async getAllusercards({
      commit,
    }, payload) {
      await apolloClient
        .query({
          query: GET_ALL_USER_CARD_GQL,
          variables: {
            groupId: payload.groupid,
            categoryId: payload.categoryid,
            month: payload.month,
            year: payload.year,
          },
          fetchPolicy: 'network-only',
        })
        .then((getAllusercardsdata) => {
          commit('shared/SET_LOADING', true, { root: true });
          const tempListOfCards = [];
          // Loading card based on group and category
          // Store in "tempListOfCards" if card has user budgets
          getAllusercardsdata.data.listuserCard.forEach((item) => {
            if (item.userbudgets.length) {
              tempListOfCards.push(item);
            }
          });
          // Sort by user name
          tempListOfCards.sort((a, b) => a.firstName.localeCompare(b.firstName));
          commit('SET_ALL_USER_CARDS', tempListOfCards);
        })
        .catch((getAllusercardserr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getAllusercardserr);
        });

      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },

    async getAllPhysicalusercards({
      commit,
    }) {
      await apolloClient
        .query({
          query: GET_ALL_USER_CARD_PHYSICAL_GQL,
          fetchPolicy: 'network-only',
        })
        .then((getAllPhysicalusercardsdata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_ALL_PHYSICAL_CARD', getAllPhysicalusercardsdata.data.listuserphysicalCard);
        })
        .catch((getAllPhysicalusercardserr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(getAllPhysicalusercardserr);
        });

      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },

    async getAllcards({
      commit,
    }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_ALL_CARD_GQL,
        })
        .then((getAllcardsdata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_ALL_CARDS', getAllcardsdata.data.listvCard);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getAllcardserr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getAllcardserr);
        });
    },

    async addNewVcard({
      commit,
    }, payload) {
      let isRecursive = null;
      let isOneTime = false;

      commit('shared/SET_LOADING', true, {
        root: true,
      });

      if (payload.isRecursive) {
        isRecursive = true;
      } else {
        isRecursive = false;
      }

      if (payload.isOneTime) {
        isOneTime = true;
      }

      const dateObj = new Date();
      const month = dateObj.getUTCMonth() + 1; // months from 1-12
      const year = dateObj.getUTCFullYear();

      await apolloClient
        .mutate({
          mutation: CREATE_VCARD,
          variables: {
            ...payload,
            isRecursive,
            isOneTime,
            amount: payload.amount.toString(),
            category: payload.category,
            bypassAvs: payload.bypassAVS,
            month,
            year,
            isHighLimitCard: payload.isHighLimitCard,
          },
        })
        .then((addNewVcarddata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          // SET Return Value
          commit('SET_V_CARD', addNewVcarddata.data.createvcard);
        })
        .catch((addNewVcarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(addNewVcarderr);
        });

      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },

    async addNewPhysicalcard({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: CREATE_PHYSICAL_CARD,
          variables: {
            nameOnCard: payload.nameoncard,
            ...payload,
            monthlyLimit: payload.monthlyLimit,
            category: payload.category,
          },
        })
        .then((addNewPhysicalcarddata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          // SET Return Value
          commit('SET_PHYSICAL_CARD', addNewPhysicalcarddata.data.createPhysicalcard);
          if (addNewPhysicalcarddata.data.createPhysicalcard.error) {
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          }
        })
        .catch((addNewPhysicalcarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(addNewPhysicalcarderr);
        });
    },

    async getAllcategory({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_SELECTED_GROUP_CATEGORIES_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getAllcategorydata) => {
          getAllcategorydata.data.timeStamp = new Date();
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_ALL_CATAGORY', getAllcategorydata.data.groups[0]);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getAllcategorydataerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getAllcategorydataerr);
        });
    },

    async getSelectedUserBudget({
      commit,
    }, payload) {
      const dateObj = new Date();
      const month = dateObj.getUTCMonth() + 1; // months from 1-12
      const year = dateObj.getUTCFullYear();
      payload.month = month;
      payload.year = year;
      await apolloClient
        .query({
          query: GET_USER_BUDGET,
          variables: {
            user: payload.user,
            category: payload.category,
            month: payload.month,
            year: payload.year,
          },
          fetchPolicy: 'network-only',
        })
        .then((
          getSelectedUserBudgetdata,
        ) => {
          commit('shared/SET_LOADING', true, { root: true });
          commit('SET_USER_ACTIVE_BUDGET', getSelectedUserBudgetdata.data.getUserBudgetFromLedger.Balance);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getSelectedUserBudgeterr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getSelectedUserBudgeterr);
        });

      // Get Actual budget from userBudget Table
      await apolloClient
        .query({
          query: GET_USER_ASSIGN_BUDGET,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(({
          data,
        }) => {
          commit('shared/SET_LOADING', true, { root: true });
          const timeStamp = dateObj.getTime();
          commit('SET_USER_BUDGET', data.userbudgets[0].amount);
          commit('SET_TIMER', timeStamp);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    async generatePin({
      commit,
    }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_CARD_PIN,
          variables: payload,
        })
        .then((
          generatePindata,
        ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_CARD_PIN_1', generatePindata.data.generatePin.text);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((generatePinerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(generatePinerr);
        });
    },

    async getAllMerchant({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: GET_ALL_MERCHANT,
          variables: payload,
        })
        .then((
          getAllMerchantdata,
        ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_ALL_MERCHANT', getAllMerchantdata.data.getAllMerchant);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getAllMerchanterr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getAllMerchanterr);
        });
    },

    async getAllMerchantCompanyWise({ commit }, payload) {
      // Skip API call and return empty data if bulk transactions is enabled
      if (isBulkTransactionsEnabled()) {
        console.log('Bulk Transactions: Skipping getAllMerchantCompanyWise API call');
        commit('SET_ALL_MERCHANT_COMPANY', []);
        return;
      }
  
      await apolloClient
        .query({
          query: GET_ALL_MERCHANT_COMPANY_WISE,
          variables: {
            companyId: payload.companyId,
          },
        })
        .then((
          getAllMerchantCompanyWisedata,
        ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          const listOfMerchat = [];
          getAllMerchantCompanyWisedata.data.getAllMerchantCompanyWise.forEach((merchants) => {
            if (merchants.Merchant) {
              listOfMerchat.push(merchants.Merchant);
            }
          });
          const key = 'name';
          const merchantList = [
            ...new Map(listOfMerchat.map(item => [item[key], item])).values(),
          ];
          commit('SET_ALL_MERCHANT_COMPANY', merchantList);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getAllMerchantCompanyWiseerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getAllMerchantCompanyWiseerr);
        });
    },

    async updateVirtualCard({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: UPDATE_VIRTUAL_CARD,
          variables: {
            ...payload,
            bypassAvs: payload.bypassAVS,
            amount: payload.amount.toString(),
            category: payload.category,
          },
        })
        .then((
          updateVirtualCarddata,
        ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_UPDATE_VIRTUAL_CARD', updateVirtualCarddata.data.updatevcard);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((updateVirtualCarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(updateVirtualCarderr);
        });
    },

    async updatePhysicalCard({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: UPDATE_PHYSICAL_CARD,
          variables: {
            id: payload.id,
            allowoverbudget: payload.allowoverbudget,
            isPerTransaction: payload.isPerTransaction,
            amountPerTransaction: payload.amountPerTransaction,
            monthlyLimit: payload.monthlyLimit,
            bypassAvs: payload.bypassAvs,
            isMerchantAllowed: payload.isMerchantAllowed,
          },
        })
        .then((
          updatePhysicalCarddata,
        ) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_UPDATE_PHYSICAL_CARD', updatePhysicalCarddata.data.updatePhysicalcard);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((updatePhysicalCarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(updatePhysicalCarderr);
        });
    },

    async getVirtualCard({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_VIRTUAL_CARD,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then((
          getVirtualCarddata,
        ) => {
          commit('shared/SET_LOADING_CHILD', true, {
            root: true,
          });
          getVirtualCarddata.data.getListofVirtualCard.sort((a, b) => a.firstName.localeCompare(b.firstName));
          const AllPhysicalCards = [];
          // User may have multlipal Physical card;
          getVirtualCarddata.data.getListofVirtualCard.forEach(async (item) => {
            if (item.cards.length > 1) {
              item.cards.forEach((card) => {
                const temp = Object.assign({}, item);
                temp.cards = [];
                temp.cards.push(card);
                AllPhysicalCards.push(temp);
              });
            } else {
              AllPhysicalCards.push(item);
            }
          });
          commit('SET_GROUPWISE_VIRTULE_CARD', AllPhysicalCards);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getVirtualCarderr) => {
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
          console.log(getVirtualCarderr);
        });
    },

    async getPhysicalCard({
      commit,
    }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_PHYSICAL_CARD,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then((getPhysicalCarddata) => {
          commit('shared/SET_LOADING_CHILD', true, {
            root: true,
          });
          getPhysicalCarddata.data.getListofPhysicalCard.sort((a, b) => a.firstName.localeCompare(b.firstName));
          const AllPhysicalCards = [];
          // // User may have multlipal Physical card;
          getPhysicalCarddata.data.getListofPhysicalCard.forEach((item) => {
            if (item.cards.length > 1) {
              item.cards.forEach((mycard) => {
                const temp = Object.assign({}, item);
                temp.cards = [];
                temp.cards.push(mycard);
                AllPhysicalCards.push(temp);
              });
            } else {
              AllPhysicalCards.push(item);
            }
          });
          commit('SET_GROUPWISE_PHYSICAL_CARD', AllPhysicalCards);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getPhysicalCarderr) => {
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
          console.log(getPhysicalCarderr);
        });
    },
    // Calcualte team excepences.
    async getTeamCalculation({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_TEAM_EXPENCE_CALCULATION_CARD,
          variables: {
            id: payload.id,
            month: Number(payload.month),
            year: Number(payload.year),
            userId: payload.userId,
            userRole: payload.userRole,
          },
          fetchPolicy: 'network-only',
        })
        .then((getTeamCalculationdata) => {
          commit('SET_TEAMWISE_EXPENCE_CARD', getTeamCalculationdata.data.teamBudgetCalculationCard);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTeamCalculationerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getTeamCalculationerr);
        });
    },
    // for Card ProgressBar.
    // Calculate team excellences.
    async getTeamCalculationProgressBar({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_TEAM_EXPENCE_CALCULATION_CARD_PROGRESSBAR,
          variables: {
            id: payload.id,
            month: Number(payload.month),
            year: Number(payload.year),
            userId: payload.userId,
            userRole: payload.userRole,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({
          getTeamCalculationProgressBardata,
        }) => {
          getTeamCalculationProgressBardata.data.date = new Date();
          commit('SET_TEAMWISE_EXPENCE_CARD_PROGRESSBAR', getTeamCalculationProgressBardata.data.teamBudgetCalculationCardProgressBar);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTeamCalculationProgressBarerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getTeamCalculationProgressBarerr);
        });
    },

    async getCardsInfo({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_CREADITCARD_INFO,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then(({
          getCardsInfodata,
        }) => {
          commit('SET_CREDITCARD_DATA', getCardsInfodata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getCardsInfoerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getCardsInfoerr);
        });
    },

    async getcategoryCalculation({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      if (payload == null) {
        commit('SET_CATEGORYWISE_EXPENCE_CARD', '[]');
      } else {
        await apolloClient
          .query({
            query: GET_CATEGORY_EXPENSE_CALCULATION_CARD,
            variables: {
              ...payload,
            },
            fetchPolicy: 'network-only',
          })
          .then((
            getcategoryCalculationdata,
          ) => {
            getcategoryCalculationdata.data.categoryBudgetCalculationCard.time = new Date();
            commit('SET_CATEGORYWISE_EXPENCE_CARD', getcategoryCalculationdata.data.categoryBudgetCalculationCard);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((getcategoryCalculationerr) => {
            commit('shared/SET_LOADING', false, {
              root: true,
            });
            console.log(getcategoryCalculationerr);
          });
      }
    },

    // For Category card Calculation
    async getcategoryCalculationProgressBar({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      if (payload == null) {
        commit('SET_CATEGORYWISE_EXPENCE_CARD_PROGRESSBAR', '[]');
      } else {
        await apolloClient
          .query({
            query: GET_CATEGORY_EXPENSE_CALCULATION_CARD_PROGRESSBAR,
            variables: {
              ...payload,
            },
            fetchPolicy: 'network-only',
          })
          .then(({ getcategoryCalculationProgressBardata }) => {
            commit('SET_CATEGORYWISE_EXPENCE_CARD_PROGRESSBAR', getcategoryCalculationProgressBardata.data.categoryBudgetCalculationCardProgressBar);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((getcategoryCalculationProgressBarerr) => {
            commit('shared/SET_LOADING', false, {
              root: true,
            });
            console.log(getcategoryCalculationProgressBarerr);
          });
      }
    },

    async getCateAccessToken({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_CLIENT_ACCESS_TOKEN,
          variables: { cardToken: payload.cardToken },
          fetchPolicy: 'network-only',
        })
        .then((getCateAccessTokendata) => {
          commit('SET_CLIENT_ACCESS_TOKEN', getCateAccessTokendata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getCateAccessTokenerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getCateAccessTokenerr);
        });
    },

    async activePhysicalCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: SET_ACTIVE_PHYSICAL_CARD_GQL,
          variables: {
            cardToken: payload.cardToken,
            ...payload,
          },
        })
        .then((activePhysicalCarddata) => {
          commit('SET_ACTIVE_PHYSICAL_CARD', activePhysicalCarddata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((activePhysicalCarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(activePhysicalCarderr);
        });
    },

    async fnblockCardVirtual({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: SET_BLOCK_CARD_GQL,
          variables: {
            cardToken: payload.cardToken,
            ...payload,
          },
        })
        .then((fnblockCardVirtualdata) => {
          commit('SET_BLOCK_VIRTUAL_CARD', fnblockCardVirtualdata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((fnblockCardVirtualerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(fnblockCardVirtualerr);
        });
    },

    async fnblockCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: SET_BLOCK_CARD_GQL,
          variables: {
            cardToken: payload.cardToken,
            ...payload,
          },
        })
        .then((fnblockCarddata) => {
          commit('SET_BLOCK_PHYSICAL_CARD', fnblockCarddata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((fnblockCarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(fnblockCarderr);
        });
    },

    async getPhysicalCardBulkDetail({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: CREATE_BULK_PHYSICAL_CARD_GQL,
          variables: {
            user: payload.user_token,
            marqetaToken: payload.token,
            allowedOverBudget: payload.allow_over_budget,
            nameOnCard: payload.nameOnCard,
            isPerTransaction: payload.isPerTransaction,
            amountPerTransaction: payload.amountPerTransaction,
            bypassAvs: payload.bypassAvs,
            monthlyLimit: payload.monthlyLimit,
            companyId: payload.companyId,
            isMetalCard: payload.isMetalCard,
            shippingAddressId: payload.shippingAddressId,
            isHighLimitCard: payload.isHighLimitCard,
          },
        })
        .then((getPhysicalCardBulkDetaildata) => {
          commit('SET_BULK_PHYSICAL_CARD', getPhysicalCardBulkDetaildata.data.returnBulkPhysicalcard);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getPhysicalCardBulkDetailerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getPhysicalCardBulkDetailerr);
        });
    },

    async getKYCStatus({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: CHECK_KYC_STATUS,
          variables: {
            ...payload,
          },
        })
        .then((getKYCStatusdata) => {
          commit('SET_KYC_STATUS', getKYCStatusdata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getKYCStatuserr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getKYCStatuserr);
        });
    },

    async createTeamVirtualCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: CREATE_VIRTUAL_CARD_FOR_TEAM,
          variables: {
            ...payload,
          },
        })
        .then((createTeamVirtualCarddata) => {
          commit('SET_TEAMWISE_CREDIT_CARD', createTeamVirtualCarddata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((createTeamVirtualCarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createTeamVirtualCarderr);
        });
    },

    async deactivateCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: DEACTIVATE_CARD,
          variables: {
            cardToken: payload.token,
            ...payload,
          },
        })
        .then((deactivateCarddata) => {
          commit('SET_ACTIVE_STATUS', deactivateCarddata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((deactivateCarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(deactivateCarderr);
        });
    },

    async shipCardAtNewAddress({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: SHIPPED_CARD_AT_NEW_ADDRESS,
          variables: {
            ...payload,
          },
        })
        .then((shipCardAtNewAddressdata) => {
          commit('SET_SHIPPING_ADDRESS', shipCardAtNewAddressdata.data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((shipCardAtNewAddresserr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(shipCardAtNewAddresserr);
        });
    },

    async getCardsList({ commit }, payload) {
      // Do not display old loader if meta data variable has true value
      const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
      commit('shared/SET_LOADING', loaderFlag, { root: true });
      await apolloClient.query({
        query: GET_ALL_CARD_LIST_GQL,
        variables: {
          companyId: payload.companyId,
          userId: payload.userId,
        },
        fetchPolicy: 'no-cache',
      }).then((getCardsListdata) => {
        const userWiseCardList = [];
        getCardsListdata.data.companies[0].users.forEach((user) => {
          if (user.cards.length > 0) {
            const userWiseCardObj = {
              userId: '', firstName: '', lastName: '', virtualCard: [], physicalCard: [], externalCard: [],
            };
            userWiseCardObj.userId = user.id;
            userWiseCardObj.firstName = user.firstName;
            userWiseCardObj.lastName = user.lastName;
            user.cards.forEach((card) => {
              card.isChecked = false;
              if (card.instrument_type === 'VIRTUAL_PAN') {
                // Virtual Card Case
                card.nameOnCardWithNo = `${user.firstName} ${user.lastName}-${card.last_four}`;
                if (userWiseCardObj.virtualCard.length === 0) {
                  const cardList = [];
                  cardList.push(card);
                  userWiseCardObj.virtualCard.push({
                    id: `SpendHub_virtual-${user.id}`, cardAccountName: 'SpendHub_virtual', isChecked: false, cardList,
                  });
                } else {
                  userWiseCardObj.virtualCard[0].cardList.push(card);
                }
              } else if (card.instrument_type === 'PHYSICAL_MSR') {
                // Physical Card Case
                card.nameOnCardWithNo = `${user.firstName} ${user.lastName}-${card.last_four}`;
                if (userWiseCardObj.physicalCard.length === 0) {
                  const cardList = [];
                  cardList.push(card);
                  userWiseCardObj.physicalCard.push({
                    id: `SpendHub_physical-${user.id}`, cardAccountName: 'SpendHub_physical', isChecked: false, cardList,
                  });
                } else {
                  userWiseCardObj.physicalCard[0].cardList.push(card);
                }
              } else if (card.instrument_type === 'EXTERNAL_CC') {
                if (card.cardAccount) {
                // External Card Case
                  const recIndex = userWiseCardObj.externalCard.findIndex(extCard => extCard.cardAccountName === card.cardAccount.cardAccountName);
                  card.nameOnCardWithNo = `${card.cardAccount.cardAccountName}-${card.last_four}`;
                  if (recIndex >= 0) {
                  // If CardAccount is alreaady there then card data only pusshed.
                    userWiseCardObj.externalCard[recIndex].cardList.push(card);
                  } else {
                    const cardList = [];
                    // If CardAccount is not there then added Card Account along with carde data pushed.
                    cardList.push(card);
                    userWiseCardObj.externalCard.push({
                      id: card.cardAccount.id, cardAccountName: card.cardAccount.cardAccountName, isChecked: false, cardList,
                    });
                  }
                }
              }
            });
            userWiseCardList.push(userWiseCardObj);
          }
        });
        commit('GET_ALL_CARD_LIST', userWiseCardList);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      }).catch((getCardsListerr) => {
        commit('shared/SET_LOADING', false, {
          root: true,
        });
        console.log(getCardsListerr);
      });
    },

    async generateCreditCardStatement({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.mutate({
        mutation: GENERATE_CREDIT_CARD_STATEMENT_GQL,
        variables: {
          ...payload,
        },
      })
        .then((generateCreditCardStatementdata) => {
          commit('GENERATE_CREDIT_CARD_STATEMENT', generateCreditCardStatementdata.data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((generateCreditCardStatementerr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(generateCreditCardStatementerr);
        });
    },

    async getStatementHistory({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_STATEMENT_HISTORY_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      }).then((getStatementHistorydata) => {
        commit('GET_STATEMENT_HISTORY', getStatementHistorydata.data);
        commit('shared/SET_LOADING', false, { root: true });
      })
        .catch((getStatementHistoryerr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(getStatementHistoryerr);
        });
    },

    async getStatementDownloadUrl({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_STATEMENT_DOWNLOAD_URL_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      }).then((getStatementDownloadUrldata) => {
        const url = getStatementDownloadUrldata.data.getStatementDownloadUrl.downloadFileUrl;
        window.open(url);
        commit('shared/SET_LOADING', false, { root: true });
      }).catch((getStatementDownloadUrlerr) => {
        commit('shared/SET_LOADING', false, { root: true });
        console.log(getStatementDownloadUrlerr);
      });
    },

    async removeStatement({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.mutate({
        mutation: SET_REMOVE_STATEMENT_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      }).then((removeStatementdata) => {
        commit('SET_REMOVE_STATEMENT_GQL', removeStatementdata.data);
      }).catch((removeStatementerr) => {
        commit('shared/SET_LOADING', false, { root: true });
        console.log(removeStatementerr);
      });
    },

    async viewCreditCardStatement({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.mutate({
        mutation: VIEW_CREDIT_CARD_STATEMENT_GQL,
        variables: {
          ...payload,
        },
      })
        .then((viewCreditCardStatementdata) => {
          const creditCardStatementData = JSON.parse(viewCreditCardStatementdata.data.viewCreditCardStatement.statementData);
          commit('VIEW_CREDIT_CARD_STATEMENT', creditCardStatementData);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((viewCreditCardStatementerr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(viewCreditCardStatementerr);
        });
    },

    async clearViewCreditCardStatementRes({ commit }) {
      commit('VIEW_CREDIT_CARD_STATEMENT', null);
    },

    async getCardsWithColorcoding({ commit }, payload) {
      // Do not display old loader if meta data variable has true value
      const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
      commit('shared/SET_LOADING', loaderFlag, { root: true });
      await apolloClient.mutate({
        mutation: GET_CARD_WITH_COLORCODING_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then((getCardsWithColorcodingdata) => {
          const userWiseCardData = [];
          // Genreating proper format of JSON file so system can render data directly
          getCardsWithColorcodingdata.data.getCardsWithColorcoding.forEach((card) => {
            // for each card group by User
            const isCardExist = userWiseCardData.filter(userCard => userCard.userId === card.userId);
            if (isCardExist.length) {
              isCardExist[0].cards.push(card);
            } else {
              const myCards = [];
              myCards.push(card);
              userWiseCardData.push({
                userId: card.userId,
                name: `${card.firstName} ${card.lastName}`,
                cards: myCards,
              });
            }
          });
          // Short by name
          const shortedValue = userWiseCardData.sort((a, b) => a.name.localeCompare(b.name));
          commit('GET_CARD_WITH_COLORCODING', shortedValue);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getCardsWithColorcodingerr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(getCardsWithColorcodingerr);
        });
    },

    async getListOfCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_CARD_LIST,
        variables: {
          companyId: payload.companyId,
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then((getListOfCarddata) => {
          commit('SET_LIST_OF_CARD', getListOfCarddata.data.getListOfCards);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getListOfCarderr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(getListOfCarderr);
        });
    },

    async getListOfGroups({ commit }, payload) {
      // Do not display old loader if meta data variable has true value
      const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
      commit('shared/SET_LOADING', loaderFlag, { root: true });
      await apolloClient.query({
        query: GET_LIST_GROUP,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then((getListOfGroupsdata) => {
          commit('SET_LIST_OF_GROUP', getListOfGroupsdata.data.getListOfGroup);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getListOfGroupserr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(getListOfGroupserr);
        });
    },

    async getSingleCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_SINGLE_USER_CARD_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then((getSingleCarddata) => {
          commit('SET_SINGLE_TRANSACTSION', getSingleCarddata.data.listSingleUserForCard);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getSingleCarderr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(getSingleCarderr);
        });
    },

    async getExtCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient.query({
        query: GET_SINGLE_USER_CARD_GQL,
        variables: {
          ...payload,
        },
        fetchPolicy: 'no-cache',
      })
        .then((getExtCarddata) => {
          commit('SET_SINGLE_TRANSACTSION', getExtCarddata.data.listSingleUserForCard);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getExtCarderr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log(getExtCarderr);
        });
    },

    async getCardTransactionDataForCsv({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: GET_CARD_TRANSACTION_DATA_FOR_CSV_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getCardTransactionDataForCsvData) => {
          commit('GET_CARD_TRANSACTION_DATA_FOR_CSV', getCardTransactionDataForCsvData.data.getCardTransactionDataForCsv);
        })
        .catch((getCardTransactionDataForCsvErr) => {
          commit('GET_CARD_TRANSACTION_DATA_FOR_CSV', { status: 'failure', error: getCardTransactionDataForCsvErr.message });
        });
    },
  },

  getters: {
    allcards: state => state.allcards,
    listuserVcard: state => state.listuserVcard,
    setvcardname: state => state.setvcardname,
    listCategory: state => state.listCategory,
    setUserBudgetAmount: state => state.setUserBudgetAmount,
    setUserActiveAmount: state => state.setUserActiveAmount,
    listAllPhysicalCard: state => state.listAllPhysicalCard,
    setPhysicalCardName: state => state.setPhysicalCardName,
    pinSet: state => state.pinSet,
    updatevirtualcard: state => state.updatevirtualcard,
    updatePhysicaCard: state => state.updatePhysicaCard,
    setRefreshTimer: state => state.setRefreshTimer,
    listOfPhysicalCard: state => state.listOfPhysicalCard,
    listOfVirtualCard: state => state.listOfVirtualCard,
    teamwiseExpence: state => state.teamwiseExpence,
    categoryExpence: state => state.categoryExpence,
    teamwiseExpenceProgressBar: state => state.teamwiseExpenceProgressBar,
    categoryExpenceProgressBar: state => state.categoryExpenceProgressBar,
    merchantList: state => state.merchantList,
    merchantListCompany: state => state.merchantListCompany,
    creditCardData: state => state.creditCardData,
    userAccessToken: state => state.userAccessToken,
    isSetactivePhysicalcard: state => state.isSetactivePhysicalcard,
    bulkCardDetails: state => state.bulkCardDetails,
    kycStatus: state => state.kycStatus,
    activeStatus: state => state.activeStatus,
    blockCard: state => state.blockCard,
    blockCardVirtual: state => state.blockCardVirtual,
    teamWiseCreditCard: state => state.teamWiseCreditCard,
    setShippingAddress: state => state.setShippingAddress,
    allCardList: state => state.allCardList,
    creditCardStatementRes: state => state.creditCardStatementRes,
    creditCardStatementHistory: state => state.creditCardStatementHistory,
    statementRemoved: state => state.statementRemoved,
    viewCreditCardStatementRes: state => state.viewCreditCardStatementRes,
    cardsWithColorCoding: state => state.cardsWithColorCoding,
    listOfAllCards: state => state.listOfAllCards,
    listOfGroup: state => state.listOfGroup,
    singleCardDetails: state => state.singleCardDetails,
    cardTransactionDataForCSV: state => state.cardTransactionDataForCSV,
  },
};
